import React from 'react';
import styles from '../../styles/stats-widget-placeholders.module.scss'
import classNames from "classnames";
import {StatsWidgetPlaceholderStat} from "./stats.widget.placeholder.stat";

export const StatsWidgetPlaceholderRow = () => {
  return (
    <div className={classNames(styles.row)}>
      <StatsWidgetPlaceholderStat/>
      <div className={classNames(styles.row_divider)}/>
    </div>
  )
};
